export default "__VITE_ASSET__BOfG5IHq__"